import { createFileRoute, stripSearchParams } from '@tanstack/react-router'
import { z } from 'zod'
import { AccountsPage } from '@/components/accounts/accounts-page'
import { stripeSubscriptionStatuses } from '@/components/accounts/account-stripe-status'

export const statusFilterValues = ['all', 'active', 'inactive'] as const

export const stripeCustomerFilterValues = [
  'all',
  'inStripe',
  'notInStripe',
] as const

export const subscriptionStatusFilterValues = [
  'all',
  ...stripeSubscriptionStatuses,
] as const

const defaultValues = {
  page: 0,
  status: 'active' as const,
  stripeCustomer: 'all' as const,
  subscriptionStatus: 'all' as const,
}

export const accountsSearchSchema = z.object({
  page: z
    .number()
    .int()
    .min(0)
    .default(defaultValues.page)
    .catch(defaultValues.page),
  cursor: z.string().nullable().optional(),
  q: z.string().optional(),
  history: z.string().optional(),
  status: z
    .enum(statusFilterValues)
    .default(defaultValues.status)
    .catch(defaultValues.status),
  stripeCustomer: z
    .enum(stripeCustomerFilterValues)
    .default(defaultValues.stripeCustomer)
    .catch(defaultValues.stripeCustomer),
  subscriptionStatus: z
    .enum(subscriptionStatusFilterValues)
    .default(defaultValues.subscriptionStatus)
    .catch(defaultValues.subscriptionStatus),
})

export const Route = createFileRoute('/_auth/_main-layout/accounts')({
  component: AccountsPage,
  validateSearch: accountsSearchSchema,
  search: {
    middlewares: [stripSearchParams(defaultValues)],
  },
})
